module.exports = __webpack_public_path__ + "static/media/close.e9c20c29.svg";